import { render, staticRenderFns } from "./smProgram.vue?vue&type=template&id=0047048c&scoped=true&"
import script from "./smProgram.vue?vue&type=script&lang=js&"
export * from "./smProgram.vue?vue&type=script&lang=js&"
import style0 from "./smProgram.vue?vue&type=style&index=0&id=0047048c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0047048c",
  null
  
)

export default component.exports